import { render, staticRenderFns } from "./DebtNoticeModal.vue?vue&type=template&id=01d35618&scoped=true&"
import script from "./DebtNoticeModal.vue?vue&type=script&lang=ts&"
export * from "./DebtNoticeModal.vue?vue&type=script&lang=ts&"
import style0 from "./DebtNoticeModal.vue?vue&type=style&index=0&id=01d35618&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d35618",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDialog})
